import { ICarriersTabProps } from "../../../interfaces/order";
import { MEDIUM } from "../../../utils/constants";
import GenericAlert from "../../GenericAlert";
import Loader from "../../Loader";
import ListOrders from "../../tables/ListOrders";
import FiltersHeaderContainer from "../FiltersHeaderContainer";

const CarriersTab = ({
  showFilters,
  handleChangeFilter,
  alert,
  setAlert,
  aliases,
  loaderPage,
  orders,
  entity,
  pagination,
  handlePageChange,
  handleSelectedAction,
  showActions,
  rules,
  allowedStatusIds,
  availableSorts,
  appliedSort,
  availableFilters,
}: ICarriersTabProps) => (
  <>
    {showFilters && (
      <FiltersHeaderContainer
        handleChangeFilter={handleChangeFilter}
        setAlert={setAlert}
        aliases={aliases}
        loaderPage={loaderPage}
        allowedStatusIds={allowedStatusIds}
        availableSorts={availableSorts}
        appliedSort={appliedSort}
        availableFilters={availableFilters}
      />
    )}
    {alert.showAlert && <GenericAlert alert={alert} />}
    {loaderPage && <Loader size={MEDIUM} />}
    {!loaderPage && orders.length > 0 && (
      <ListOrders
        orders={orders}
        entity={entity}
        pagination={pagination}
        handlePageChange={handlePageChange}
        handleSelectedAction={handleSelectedAction}
        showActions={showActions}
        rules={rules}
        availableSorts={availableSorts}
        appliedSort={appliedSort}
        handleChangeFilter={handleChangeFilter}
      />
    )}
  </>
);

export default CarriersTab;
